import { apiService } from 'services';
import { IPhoneNumber } from 'services/PhoneNumber';
import { AxiosError } from 'axios';

export interface IPhoneSubmitRequest {
    countryCode: string;
    phoneNumber: string;
    extension: string;
}

export interface IPhoneSubmitResponse {
    maskedNumber: string;
    uniqueId: string;
}

export const getPhoneNumbers = (callback: any, errorCallback: any) => {
    apiService.get<IPhoneNumber[]>('/phone/numbers', callback, errorCallback);
};

export const sendSMS = (body: any, callback: any, errorCallback: any) => {
    apiService.post<any>('/phone/send', body, callback, errorCallback);
};

export const sendCall = (body: any, callback: any, errorCallback: any) => {
    apiService.post<any>('/phone/call', body, callback, errorCallback);
};

export const submitPhoneNumber = (body: IPhoneSubmitRequest, callback: (response: IPhoneSubmitResponse) => void, errorCallback: (error: AxiosError) => void) => {
    apiService.post<IPhoneSubmitResponse>('/phone/submit', body, callback, errorCallback);
};
